export const metatags = {
    description_sv: "Vi erbjuder IT-lösningar – allt från idéstadiet till utveckling, drift och förvaltning. Firebric - det personliga alternativet."
}
